module.exports = __webpack_public_path__ + "static/2front-about-company-3-698ea8a54d1ab604d2def66d7ccff3ea.png";